/* eslint semi:0 */
import { memoizeFirstCall, } from '../../jsCore/utils/fn'
import { getApiEndpoints, } from '../../jsCore/application/api'
import { getLeaguesForFixtures, } from '../../jsCore/application/pageDataObject'
import { FETCH_REQUEST_ACTION_TYPE, } from '../../jsCore/application/sagas/fetchSaga'


export const API_ENDPOINT_NAME = 'SCORES_TABLES'

function filterTablesBasedOnLeaguesForFixtures(leagueTable){
  const leagueIdsFromEdition = getLeaguesForFixtures().map(league => league.id)
  return leagueIdsFromEdition.includes(+leagueTable.league.id)
}

function reduceToScoreTablesByLeagueIdMap(acc, table){
  return {
    ...acc,
    [table.league.id]: table,
  }
}

function dataTransformer({ tables, }){
  const scoresTableList = tables
    .filter(filterTablesBasedOnLeaguesForFixtures)
    .reduce(reduceToScoreTablesByLeagueIdMap, {})
  return {
    tables: scoresTableList,
  }
}

export function fetchScoresTables(){
  const {
    scoresTableEndpoint: { url, endpointName, },
  } = memoizeFirstCall(
    'scoresTableEndpoint',
    getApiEndpoints,
    API_ENDPOINT_NAME
  )
  return (dispatch, getState) => dispatch({
    type: FETCH_REQUEST_ACTION_TYPE,
    payload: {
      url,
      endpointName,
      dataTransformer,
      additionalState: {
        IS_INITIALIZED: true,
      },
    },
  })
}

export const scoresTableActions = { fetchScoresTables, }


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/scores_table/scoresTableActions.js